import * as types from "./actionTypes";

export const setGroheFiltersOpened = (filtersOpened = false) => ({
  type: types.SET_GROHE_FILTERS_OPENED,
  payload: {filtersOpened}
});

export const setGroheSimilarFeature = (similarFeature = false) => ({
  type: types.SET_GROHE_SIMILAR_FEATURE,
  payload: {similarFeature}
});

export const setGroheSimilarProductsOpened = (similarProductsOpened = false) => ({
  type: types.SET_GROHE_SIMILAR_PRODUCTS_OPENED,
  payload: {similarProductsOpened}
});

export const setGroheRequiredButNotIncludedFeature = (requiredButNotIncludedFeature= false) => ({
  type: types.SET_GROHE_REQUIRED_BUT_NOT_INCLUDED_FEATURE,
  payload: {requiredButNotIncludedFeature}
});

export const setGroheFiltersSearchText = (groheFiltersSearchText = "") => ({
  type: types.SET_GROHE_FILTERS_SEARCH_TEXT,
  payload: {groheFiltersSearchText}
});

export const setLastOpenedCategory = (lastOpenedCategory = "") => ({
  type: types.SET_GROHE_LAST_OPENED_CATEGORY,
  payload: {lastOpenedCategory}
});

export const setGroheSubCategoryOpened = (subCategoryOpened = "") => ({
  type: types.SET_GROHE_SUB_CATEGORY_OPENED,
  payload: {subCategoryOpened}
});

export const setShowAddedToTheCartSuccess = (showAddedToTheCartSuccess = "") => ({
  type: types.SET_GROHE_SHOW_ADDED_TO_THE_CART_SUCCESS,
  payload: {showAddedToTheCartSuccess}
});

export const setGroheActiveFeatureQuantity = (groheActiveFeatureQuantity = "") => ({
  type: types.SET_GROHE_ACTIVE_FEATURE_QUANTITY,
  payload: {groheActiveFeatureQuantity}
});

export const setGroheShareButtonsOpened = (groheShareButtonsOpened = "") => ({
  type: types.SET_GROHE_SHARE_BUTTONS_OPENED,
  payload: {groheShareButtonsOpened}
});

export const setGroheSameColorActiveFeature = (groheSameColorActiveFeature = "") => ({
  type: types.SET_GROHE_SAME_COLOR_ACTIVE_FEATURE,
  payload: {groheSameColorActiveFeature}
});

export const setGroheSameColorSectionOpened = (groheSameColorSectionOpened = "") => ({
  type: types.SET_GROHE_SAME_COLOR_SECTION_OPENED,
  payload: {groheSameColorSectionOpened}
});

export const setGroheSameColorCheckboxApplied = (groheSameColorCheckboxApplied = "") => ({
  type: types.SET_GROHE_SAME_COLOR_CHECKBOX_APPLIED,
  payload: {groheSameColorCheckboxApplied}
});

export const setExisingTempId = (exisingTempId = "") => ({
  type: types.SET_GROHE_EXISTING_TEMP_ID,
  payload: {exisingTempId}
});
